const mistakes = [
  {
    mistake: '«Ты всегда…» и «Ты никогда…»',
    explanation: 'Обобщения делают обратную связь неконкретной и заставляют сотрудника защищаться вместо того, чтобы услышать суть.',
    fix: 'Говорить о конкретном случае: «На прошлой неделе в проекте X ты...»',
  },
  {
    mistake: 'Разговор на эмоциях',
    explanation: 'Эмоциональный разговор воспринимается как атака. Сотрудник слышит тон, а не содержание.',
    fix: 'Если эмоции зашкаливают — взять паузу и вернуться к разговору в спокойном состоянии.',
  },
  {
    mistake: 'Публичная критика',
    explanation: 'Публичное замечание унижает сотрудника и формирует у команды страх, а не уважение к руководителю.',
    fix: 'Корректирующую обратную связь давать только наедине. Положительную — можно публично.',
  },
  {
    mistake: 'Обобщения вместо фактов',
    explanation: '«Ты плохо работаешь» — это оценка, а не обратная связь. Сотрудник не понимает, что именно нужно изменить.',
    fix: 'Использовать конкретные примеры: «В отчёте за июль три ошибки в расчётах...»',
  },
  {
    mistake: 'Слишком длинная лекция',
    explanation: 'Руководитель говорит 80% времени, сотрудник молчит и ждёт окончания. Диалога не происходит.',
    fix: 'Говорить 30% времени, 70% — слушать. Задавать вопросы о причинах и видении сотрудника.',
  },
  {
    mistake: 'Попытка сразу дать решение',
    explanation: 'Руководитель не даёт сотруднику подумать и предложить свой вариант, лишая его ответственности.',
    fix: 'Сначала спросить сотрудника: «Как ты видишь решение? Что можно сделать?»',
  },
  {
    mistake: 'Угрозы вместо управления',
    explanation: '«Если ещё раз...» — угрозы создают страх и формальное послушание, а не ответственность.',
    fix: 'Описывать последствия с точки зрения бизнеса: «Если сроки продолжают срываться, нам придётся пересмотреть...»',
  },
  {
    mistake: 'Перенос разговора на неопределённый срок',
    explanation: '«Поговорим позже» — проблема никуда не уходит, а руководитель теряет авторитет.',
    fix: 'Назначать конкретное время разговора сразу, как только проблема замечена.',
  },
  {
    mistake: 'Отсутствие договорённостей',
    explanation: 'Разговор завершается, но не зафиксировано, что именно изменится и когда будет проверка.',
    fix: 'Завершать фразой: «Итак, мы договорились, что до пятницы ты... Я проверю в пятницу в 15:00.»',
  },
  {
    mistake: 'Отсутствие последующего контроля',
    explanation: 'Договорились, но не проверили. Сотрудник понимает, что обратная связь — это ритуал, а не инструмент управления.',
    fix: 'Фиксировать дату следующей проверки и проводить её в назначенное время.',
  },
  {
    mistake: 'Попытка понравиться вместо управления',
    explanation: 'Руководитель смягчает обратную связь до такой степени, что сотрудник не воспринимает её всерьёз.',
    fix: 'Быть доброжелательным, но требовательным. Уважение важнее симпатии.',
  },
  {
    mistake: 'Отсутствие конкретного примера',
    explanation: '«Мне кажется, ты стал менее ответственным» — расплывчато, сотрудник может искренне не понимать, о чём речь.',
    fix: 'Приводить конкретную ситуацию с датами, цифрами, фактами.',
  },
];

export default function TypicalMistakes() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
          Что мешает обратной связи работать
        </h2>
        <p className="text-base md:text-lg text-gray-600 mb-12 max-w-3xl leading-relaxed">
          Типичные ошибки руководителей при проведении сложных разговоров, их последствия и способы исправления
        </p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-gray-200">
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-900 w-1/4">Ошибка</th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-900 w-2/5">Почему не работает</th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-900 w-1/3">Как исправить</th>
              </tr>
            </thead>
            <tbody>
              {mistakes.map((m, i) => (
                <tr key={i} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                  <td className="py-3 px-4 text-sm text-red-700 font-semibold align-top">{m.mistake}</td>
                  <td className="py-3 px-4 text-sm text-gray-600 align-top">{m.explanation}</td>
                  <td className="py-3 px-4 text-sm text-teal-700 align-top">{m.fix}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Избегание сложного разговора часто воспринимается как мягкость, но для команды оно может означать отсутствие понятных правил и требований.
          </p>
        </div>
      </div>
    </section>
  );
}